//韩语文件
module.exports = {
  header1: "Домашняя страница",
  header2: "О нас",
  header2_1: "Кто мы",
  header2_2: "Почему выбирают нас",
  header3: "Торговая платформа",
  header4: "Руководство по MT5",
  header5: "Свяжитесь с нами",
  header6: "Открыть реальный счет",
  header7: "Войти",
  header8: "Зарегистрироваться",
  footer1: "Пополняй ряды трейдеров",
  footer2: "Бесплатная пробная версия",
  footer3: "Начните торговать немедленно",
  footer4: "Следуйте за нами",
  footer5: "Авторские права",
  footer6: "Все права защищены",
  home1: "Торговые продукты",
  home2: "Депозит бесплатно",
  home3: "Разница до нуля",
  home4: "Торговать можно где угодно",
  home5: "Более 200 торгуемых товаров",
  home6: "9 вариантов периода времени",
  home7: "Вы можете войти в свою учетную запись на ПК и мобильном телефоне",
  home8: "Инструменты профессионального анализа",
  home9: "Скачать MT5 для ПК",
  home10: "Интернет-трейдер",
  home11: "Не нужно скачивать и устанавливать",
  home12: "Доступ к вашей учетной записи в любом веб-браузере",
  home13: "Такой же мощный, как MT4",
  home14: "Подключайтесь к рынку для транзакций в любое время и в любом месте",
  home15: "Откройте веб-версию mt5",
  home16: "Помогите сделать это",
  home17: "Лучшее торговое решение",
  home18:
    "Используйте эти торговые инструменты, чтобы помочь вам принять наиболее обоснованное решение",
  home19: "Интеллектуальная торговая система",
  home20: "Получите торговые преимущества с профессиональным советником",
  home21: "Торговый сигнал",
  home22: "Он ведет к успеху, как маяк.",
  home23: "Экономический календарь",
  home24: "Освойте последние тенденции рынка",
  home25: "Protrader Tool",
  home26: "Получите больше торговых возможностей",
  home27: "Новости рынка",
  home28: "Избранные обзоры рынка",
  home29: "Взгляд аналитика",
  home30: "Профессиональный экономический календарь",
  home31: "Откройте торговый счет и внесите не менее 1000 долларов США",
  home32:
    "Вы можете использовать полный набор профессиональных торговых инструментов",
  home33: "Мгновенный депозит",
  home34: "Открыть реальный счет",
  home35: "Идеальный опыт",
  home36: "Чрезвычайно быстрое исполнение торговых приказов",
  home37:
    "' Каковы ключевые элементы, когда трейдеры выбирают брокера по обмену валют? '- этот вопрос мы постоянно задаем себе при создании {platform}. Мы считаем, что эти элементы определяют нашу ценность и позволяют нам удовлетворить наших клиентов. требовать и продолжать предоставлять безупречный и надежный сервис. ",
  home38: "Открытие счета за 5 минут",
  home39: "Комбинация из более чем 200 торгуемых товаров",
  home40: "Полнофункциональная система управления аккаунтом",
  home41: "Отличная ликвидность рынка",
  home42: "Узнать больше",
  home43: "Надзор за соблюдением требований",
  home44: "Обеспечьте максимальную безопасность",
  home45:
    "{platform} придает большое значение контролю и безопасности. Мы обеспечиваем всем клиентам прозрачную и безопасную среду для торговли иностранной валютой.",
  home46: "Глобальный офис",
  home47: "Многонациональный надзор",
  home48: "Сотрудничество с ведущими финансовыми институтами мира",
  home49: "Страхование денежных средств",
  home50: "Надзор",
  home51: "Компенсация",
  home52: "Страхование",
  home53: "Метод депозита",
  home54: "Партнеры по ликвидности рынка",
  home55:
    "{platform} сотрудничает с более чем 14 ведущими мировыми поставщиками котировок ликвидности, и достаточная ликвидность может предоставить вам лучшие торговые котировки на рынке",
  home56: "Торговля иностранной валютой",
  home57:
    "Воспользовавшись глобальными экономическими потрясениями для подключения к самому ликвидному финансовому рынку в мире",
  home58: "Начните торговать немедленно",
  home59: "Торговля крупными товарами",
  home59_1: "Крупная транзакция",
  home60:
    "Выбирайте золото, серебро, сырую нефть или другие сырьевые товары на основе основного торгового цикла рынка",
  home61: "Индексная торговля",
  home61_1: "Индекс",
  home62:
    "Торгуйте на колебаниях крупнейших мировых фондовых индексов, таких как SP500, DJ30, FRA40 и DAX30",
  home63: "Фондовая биржа США / Гонконга",
  home64:
    "Освойте тенденции крупных глобальных компаний и торгуйте акциями США и Гонконга с помощью CFD",
  home65: "Контракт на разницу",
  home66: "Глобальный бизнес",
  home67:
    "Для нас большая честь предоставлять клиентам первоклассный и стабильный сервис",
  home68: "Торговля веб-версией",
  who0: "Кто такая {платформа}",
  who1: "Присоединяйтесь к самому инновационному брокеру",
  who2:
    "{platform} Она имеет более чем 10-летний опыт и знания на мировом финансовом рынке и стремится обеспечить простой и прозрачный доступ к рынкам и помощь клиенты достигают финансовой цели.",
  who3:
    `{платформа} 2010년 영국에 설립된 이 회사는 항상 "언제 어디서나 거래를 즐기십시오"라는 개념을 고수하여 고급 기술 서비스를 사용하여 고객에게 외환 시장에서 우수한 거래 경험을 제공합니다. 고속 거래 및 강력한 클라이언트 관리 시스템 등`,
  who4: "Выберите надежного валютного брокера",
  who5:
    "{platform1} всегда стремился предоставить клиентам отличную торговую среду и всегда настаивал на том, чтобы превзойти ожидания глобальных финансовых регуляторов. В этой отрасли мы понимаем, что трейдеры стремятся найти надежную платформу. {platform2 } Под контролем нескольких организаций мы накопили более 10 000 активных торговых счетов клиентов со всего мира, и все они полагаются на {platform3} для обеспечения безопасности своих средств. ",
  who6: "Главное регулирующее агентство",
  who7: "Глобальное количество людей",
  who8:
    "Являясь одним из лидеров мирового финансового рынка, {platform} предоставляет нашим клиентам первоклассные и стабильные услуги.",
  who9: "Ниже приведены некоторые важные данные о {платформе}:",
  who10: "10 лет +",
  who11: "Отраслевая квалификация",
  who12: "Более 1,5 миллиарда",
  who13: "ежемесячный объем транзакций",
  who14: "Более 7 млн",
  who15: "Учетная запись клиента",
  who16: "1,5 миллиарда долларов",
  who17: "Ежемесячный объем транзакции",
  why0: "Почему выбирают {platform}",
  why1: "Не просто платформа, а партнер",
  why2:
    "' Чего хотят трейдеры при выборе валютного брокера? '-Эти вопросы мы постоянно задавали себе, когда основали {platform}. Я считаю, что эти элементы являются ядром, определяющим наши ценности, чтобы мы могли удовлетворять потребности наших клиентов и продолжать предоставлять отличные и надежные услуги.",
  why3:
    "Самое главное, что мы хотим создать бренд, который известен не только по цене или продукту. Мы хотим стать брендом, которым торгуют в новом поколении. Знание потребностей наших клиентов позволяет нам вносить изменения. более гибко. Мы - новый высокопроизводительный бренд. Торговая платформа Generation, {platform} всегда рядом с вами, когда вам это нужно. ",
  why4: "Мы на вашей стороне на протяжении всего торгового пути",
  why5:
    "Независимо от того, являетесь ли вы новичком или ветераном торговли на протяжении многих лет, наша команда окажет вам поддержку в любое время. Наша платформа всегда с вами, в любом месте, и наша служба поддержки клиентов сопровождает вас на каждом этапе пути. Мы будет сопровождать вас, чтобы расти вместе. Хотя наши конкуренты могут быть сильнее нас, у нас есть стремление к инновациям и поддержка соответствующей торговой платформы. Узнайте, почему {платформа} - ваш правильный выбор: ",
  why6: "Открыть реальный счет сразу за 5 минут",
  who6_1: "Регламент NFA США, регистрационный номер: 0542569",
  why7: "Кредитное плечо до 500: 1",
  why8: "Можно торговать более чем 200 видами товаров",
  why9: "Предоставить дополнительный торговый бонус",
  why10: "Мощная система управления клиентами",
  why11: "Отличная ликвидность рынка",
  why12: "Несколько регулирующих органов и отдельные счета в качестве гарантии",
  trading1: "Использовать платформу Metatrader5",
  trading2: "Торгуйте в любое время и в любом месте",
  trading3:
    "Если вы новый клиент {platform}, просто заполните форму вверху этой страницы, и вы сможете использовать торговую платформу MT5 в течение нескольких минут",
  trading4:
    "Если вы уже являетесь клиентом {platform}, который торгует на платформе MT5, вам нужно только войти в систему управления клиентами, щелкнуть, чтобы открыть свою учетную запись и выбрать MetaTrader5, вы можете легко переключиться на MT5 и усовершенствовать ваш торговый опыт. ",
  trading5:
    "Мобильное приложение MT5 позволяет подключаться к {платформе} в любое время и в любом месте и пользоваться услугами торговли в любую погоду",
  guide0: "Руководство по MT5",
  guide1: "Загрузите MT5 на свой компьютер",
  guide3: "Как вставить квоту диаграммы?",
  guide3_0: "Выполните следующие действия:",
  guide3_1: "1) В верхней строке меню выберите вставку квоты.",
  guide3_2: "2) Вы также можете вставить квоту из раздела навигации.",
  guide4: "Как избежать защиты брандмауэром?",
  guide4_1:
    "Запретите вашему антивирусному файерволу применять для MetaTrader 4 и откройте порт 1950. Для MetaTrader 5 откройте порт 443.",
  guide5: "Как создать линии тренда и другие линии исследования?",
  guide5_1: "1) В верхнем столбце меню выберите' Вставить '",
  guide5_2: "2) Выберите желаемую линию тренда.",
  guide5_3:
    "3) После отпускания кнопки мыши появится значок изображения выбранной линии тренда с перекрестием. Используйте мышь, чтобы разместить перекрестие на выбранной диаграмме. Щелкните мышью, удерживайте для перемещения Используйте мышь для настройки размер линии тренда. ",
  guide5_4:
    "К ярлыку исследования линии можно также быстро получить доступ, щелкнув на панели инструментов' Обзор 'исследование линии, так что значок просто появится под списком функций.",
  guide5_5:
    "Вы также можете выбрать другие параметры, которые отображаются в верхней части экрана. В том числе щелчок по линиям тренда, перекрестию, ретрейсментам Фибоначчи и т. д.",
  guide6: "Как отобразить гистограмму?",
  guide6_1:
    "В строке меню вверху выберите 'Диаграмма гистограммы 'или воспользуйтесь сочетанием клавиш (Alt + 1)",
  guide7:
    "Как получить информацию о счете и ежедневных транзакциях на платформе Metatrader?",
  guide7_1:
    "Используйте терминальную (ТЕРМИНАЛ) часть платформы. Если вы не открываете эту часть, вы можете просмотреть терминал ТЕРМИНАЛ или использовать сочетание клавиш Cntrl + t.",
  guide7_2: "В разделе терминала выберите' Тег истории аккаунта ''.",
  guide7_3:
    "Эта отметка показывает вам историю вашей учетной записи. Для вашего удобства ее также можно распечатать.",
  guide7_4: "Щелкните правой кнопкой мыши в любом месте этого раздела.",
  guide7_5:
    'Выберите" Сохранить как отчет ". (Его также можно сохранить как файл HTML, который можно преобразовать в файл Excel для записи.)',
  guide8: "Как вывести свечной график?",
  guide8_1:
    'В верхней строке меню выберите" Графическая свеча "или воспользуйтесь сочетанием клавиш (Alt + 2).',
  guide9:
    "Могу ли я использовать интерфейс приложения MetaTrader в вашей системе? Можно ли сначала сделать это на мини / аналоговом счете?",
  guide9_1:
    "Да, до тех пор, пока вы хотите, вы можете сначала использовать аналоговую учетную запись. Как правило, к интерфейсу приложения для реального доступа к системе применяются определенные положения и условия. Обязательно обсудите свой проект с представителем FXDD, чтобы , Они могут вам помочь. ",
  guide10: "Как отобразить линейный график?",
  guide10_1:
    'В верхней строке меню выберите" Линейный график диаграммы "или воспользуйтесь сочетанием клавиш (Alt + 3)."',
  guide11: "Как увеличить или уменьшить масштаб диаграммы?",
  guide11_1: "1) Убедитесь, что панель инструментов' Диаграмма 'включена",
  guide11_2:
    "2) Затем выберите значок разумного действия, расположенный под списком функций, а именно" +
    "и" -
    ".",
  guide11_3:
    "3) Выберите один из двух значков, чтобы увеличить или уменьшить масштаб.",
  guide11_4:
    "Или используйте сочетание клавиш для этой функции. Увеличение - (Shift +), а уменьшение - (-).",
  guide12: "Помогает ли платформа MetaTrader в торговле мини-руками (10K)?",
  guide12_1:
    "Да, вы можете использовать платформу MetaTrader для торговли мини-лотами (10K).",
  guide12_2:
    "Ниже приводится диапазон размеров лотов, которые мы используем для торговли в Metatrader:",
  guide12_3:
    "0.01 лот = 1000 базовой валюты организации (или доллара США) наш' супер мини 'лот.",
  guide12_4:
    "0.10 лота = 10000 базовой валюты организации (или доллара США) наш' мини 'лот.",
  guide12_5:
    "1.00 лот = 100000 наш' стандартный 'лот базовой валюты организации (или доллара США).",
  guide13:
    "Я загрузил платформу. Как мне войти в свою реальную учетную запись, чтобы торговать?",
  guide13_1:
    "Пользователь должен был получить уведомление по электронной почте об утверждении учетной записи. Имя для входа и пароль указаны в уведомлении (т. е. имя для входа -' 81234 ', а пароль -' xxxxx '). Это информация об учетной записи для ваша реальная учетная запись. Если вы загрузили платформу и открыли экран входа в систему. Обратите внимание, что на открывшемся в это время экране будет предложено открыть учетную запись. Вы можете нажать 'X', чтобы выйти из этого экрана. ",
  guide13_2:
    "При входе в систему выберите' Вход в файл ' и введите свое имя пользователя и пароль.",
  guide13_3:
    "В поле сервера есть раскрывающееся меню, выберите следующий сервер:' FXDD-MT5 Live Server 2-FXDD '.",
  guide13_4:
    "Послушайте' динь '(сигнал подтверждения), ваша учетная запись появится в верхнем левом углу платформы.",
  guide13_5:
    "Если вы видите движение цены в Обзоре рынка и правильный баланс отображается в терминальной части, это означает, что вы успешно вошли в свою реальную учетную запись. Если у вас возникли проблемы при входе в систему, отправьте электронное письмо по адресу info @fxbritt. com. ",
  guide14: "Как изменить пароль в MetaTrader?",
  guide14_1:
    "В верхней строке меню выберите' Параметры инструмента 'или сочетание клавиш (Ctrl + O).",
  guide14_2: "Под значком' Сервер 'выберите' Изменить ''.",
  guide14_3: "Введите текущий пароль в текстовое поле' Текущий пароль '.",
  guide14_4: "Отметьте' Изменить главный пароль '.",
  guide14_5: "Введите новый пароль в текстовое поле' Новый пароль '.",
  guide14_6:
    "Введите новый пароль еще раз во втором текстовом поле' Подтвердить '.",
  guide15: "Как выбрать язык?",
  guide15_1:
    "В верхней строке меню выберите' Обзор языка ', выберите нужный язык. Затем закройте платформу и перезапустите программу.",
  guide16:
    "Какие сочетания клавиш можно использовать для отображения различных окон на платформе?",
  guide16_1: "Наиболее часто используемые сочетания клавиш:",
  guide16_2: "Ctrl + M = окно наблюдения за рыночными ценами",
  guide16_3: "Ctrl + N = окно навигации",
  guide16_4: "Ctrl + T = окно терминала",
  guide17: "Как просмотреть все валютные пары, предоставленные FXDD?",
  guide17_1:
    "В окне' Обзор рынка 'щелкните правой кнопкой мыши и выберите' Показать все ', чтобы просмотреть все валютные пары, по которым можно торговать. Все валютные пары могут быть отображены в любое время.",
  guide18:
    "Как отобразить максимальные / минимальные цены в окне' Обзор рынка '?",
  guide18_1:
    "В окне' Обзор рынка 'выполните следующие действия, чтобы отобразить максимальные / минимальные цены:",
  guide18_2: "Щелкните правой кнопкой мыши (любую часть) в окне' Обзор рынка '",
  guide18_3:
    "Выберите' Максимум '/' Минимум '. (В это время появятся максимальные и минимальные цены каждой валютной пары дня.)",
  guide19: "Можете ли вы помочь в создании диаграмм? Какие есть варианты?",
  guide19_1:
    "Да, платформа MetaTrader 5 - одна из самых продвинутых платформ на рынке, особенно с графическими опциями и пакетами.",
  guide19_2:
    "Используйте параметр' Разделы справки 'в меню' Справка '(нажмите F1) и отметьте раздел' Начать работу с диаграммой '. Этот раздел следует использовать как хорошее начало.",
  guide19_3:
    "Вы можете изменить общий вид диаграммы (' Список функций '-' Диаграмма '-' Содержимое '). Вы можете изменить цвет фона, переднего плана, таблицы и т. д. Вы можете прокручивать край окно диаграммы, чтобы настроить размер диаграммы, и потяните кнопку мыши вниз, чтобы изменить размер. ",
  guide20: "Как изменить период отображения графиков MetaTrader?",
  guide20_1:
    "При добавлении ограничения по времени в строку главного меню выберите' Обзор панели инструментов '.' Период '(при необходимости). Используйте следующую легенду, чтобы использовать ограничение по времени на диаграмме:",
  guide20_2: "M1 = 1-минутный график",
  guide20_3: "M5 = 5-минутный график",
  guide20_4: "M15 = 15-минутный график",
  guide20_5: "M30 = 30-минутный график",
  guide20_6: "H1 = 1 часовой график",
  guide20_7: "H4 = 4-часовой график",
  guide20_8: "D1 = Дневной график",
  guide20_9: "W1 = недельный график",
  guide20_10: "MN = Месячный график",
  guide21: "Есть ли руководство по MetaTrader 5?",
  guide21_1:
    "Да, выберите' Разделы справки 'на платформе или щелкните здесь, чтобы загрузить. Обратите внимание, что у нас есть онлайн-семинары, которые могут помочь вам понять функции этой платформы. Если вы хотите участвовать в этих онлайн-семинарах: Да, отправьте электронное письмо в отдел продаж. ",
  guide22:
    "Какой часовой пояс на платформе Metatrader? Можно ли это время скорректировать?",
  guide22_1:
    "Летом время клиента на MetaTrader составляет GMT + 3 (среднее время по Гринвичу плюс 3 часа, пекинское время плюс 5 часов). К сожалению, время на платформе MetaTrader не может быть изменено. Все, что связано с этим, мы глубоко Приносим извинения за неудобства.",
  guide23: "Как открыть еще один аналоговый счет на платформе MetaTrader?",
  guide23_1: "Выберите' Файл для открытия учетной записи 'в платформе",
  guide23_2:
    "Заполните необходимую информацию (обязательно отметьте столбец' Я согласен подписаться на вашу рассылку ')",
  guide23_3: "Выберите' Далее '(на странице сервера)",
  guide23_4:
    "Выберите' Далее '(обратите внимание, что появятся ваше имя пользователя и пароль)",
  guide23_5: "Выберите' Готово '",
  guide23_6:
    "Это программное обеспечение автоматически войдет в вашу новую аналоговую учетную запись и отобразит ее в окне навигации.",
  guide24: "Какие факторы влияют на объем общения в программе?",
  guide24_1:
    "Объем выходных сообщений зависит от активности пользователя, и объем довольно небольшой. Объем входных сообщений напрямую зависит от количества открытых окон графиков.",
  guide25: "Могу ли я получать предупреждения по электронной почте?",
  guide25_1:
    "Выполните следующие шаги, чтобы создать оповещение по электронной почте в MetaTrader 5:",
  guide25_2:
    "(Все настройки SMTP-протокола различаются в зависимости от интернет-провайдера. Если вы получили сообщение об ошибке, обратитесь в службу технической поддержки своего интернет-провайдера и попросите их внедрить простой протокол передачи почты. Если вы используете Outlook, вы можете выберите 'Инструменты изменения учетной записи электронной почты, следующий шаг', чтобы отменить, когда закончите), чтобы установить простой протокол передачи почты. ",
  guide25_3: "Выберите' Параметры инструмента '.",
  guide25_4: "Выберите значок' Электронная почта '.",
  guide25_5:
    "Измените указанные выше настройки в соответствии с требованиями вашего интернет-провайдера. Обычно светло-красный текст является общим указанием, которое вы должны выполнить для входа в систему. Пожалуйста, обратитесь к своему интернет-провайдеру за конкретными инструкциями. (Примечание: недоступные веб-службы электронной почты включают Hotmail, Yahoo, Gmail и т. Д.) ",
  guide25_6:
    "Сервер простого протокола передачи почты - это адрес почтового сервера вашего интернет-провайдера",
  contact1: "Когда мы вам понадобимся, мы всегда рядом",
  contact2:
    "Если у вас есть какие-либо вопросы или вам нужна дополнительная помощь, свяжитесь с нами, используя следующие методы связи. Мы постараемся ответить на все вопросы как можно скорее.",
  contact3: "Регистрация",
  contact4: "Офис на Каймановых островах",
  contact5: "офис",
  contact6: "№ 7, секция 5, район Синьи, Тайбэй, Тайвань (Тайбэй 101)",
  contact7: "Адрес электронной почты",
  contact8: "Телефон",
  address1: "Австралия, Сидней",
  address2: "Тайбэй",
  address3: "Таиланд, Бангкок",
  address4: "Малайзия, Куала-Лумпур",
  address5: "Великобритания, Лондон",
  address6: "США, Нью-Йорк",
  address7: "Сингапур, город Сингапур",
  address8: "Каймановы острова, Джорджтаун",
  адрес9: "Кипр, Никосия",
  address10: "Гонконг",
  address11: "Вьетнам, Ханой",
  address12: "Австралия, Мельбурн"
};



// WEBPACK FOOTER //
// ./src/common/lang/ru.js